import AutoSubmit from "../components/AutoSubmit";
import BulkAction from "../components/BulkAction";
import TriggerFileUpload from "../components/TriggerFileUpload";

export default class SimplifiAudiences {
  constructor(params) {
    this.params = params;
  }

  index() {
    new AutoSubmit();

    new BulkAction({
      target: "#audiences-bulk-store",
      action: "#audiences-bulk-action",
      secondary_nav: "#audiences-action-bar",
      checked_scope: "td",
    });

    new N2Styles.searchBar({
      safeContainer: ".js-table-search",
      showSelector: ".show-table-search",
      visible: this.params.search,
    });

    new TriggerFileUpload();
  }
}
